// utils/notifications.js
export function globalNotificationsListContainer(resOrErr) {
  const newNotificationList = Array.isArray(resOrErr?.data?.notifications)
    ? resOrErr.data.notifications
    : null;
  if (newNotificationList) return newNotificationList;

  // works for thrown axios errors too; harmless if not axios-shaped
  const notificationListError = Array.isArray(
    resOrErr?.response?.data?.notifications
  )
    ? resOrErr.response.data.notifications
    : null;

  return notificationListError || [];
}
const KEY = (userId) => `skitsicon.unread.badge.${userId}`;

export function writeUnreadBadge(userId, count) {
  try {
    if (!userId) return;
    const n = Math.max(0, Number(count) || 0);
    localStorage.setItem(KEY(userId), String(n));
  } catch {}
}

export function clearUnreadBadge(userId) {
  try {
    if (!userId) return;
    localStorage.removeItem(KEY(userId));
  } catch {}
}


